export default {
    check_lists: [],
    check_lists_all: [],
    check_list: null,
}
